import CubeGeometryLoader from "../../output/assets/geometries/cube-geometry-loader.js";

class ThreeCubeGeometryLoader extends CubeGeometryLoader {
    constructor() {
        super();
    }

    load(width, height, depth) {
        return new THREE.BoxBufferGeometry(width, height, depth);
    }

    unload(geometry) {
        geometry.dispose();
    }
}

export default ThreeCubeGeometryLoader;
